import { CSSProperties, JSX } from "react";
import { useTranslation } from "react-i18next";

import { IconRadio } from "@/components/icons";

import { Price } from "@/@types/subscriptions.ts";
import { COLORS } from "@/config/colors.ts";
import { cn } from "@/utils/cn.ts";

interface TariffCardProps extends Omit<Price, "currency" | "discount_str" | "no_discount_price"> {
  value: Price | undefined;
  style?: CSSProperties;
  className?: string;
}

const TariffCard = ({
  id,
  value,
  cashback_percentage,
  period,
  price,
  style,
  className,
}: TariffCardProps): JSX.Element => {
  const { t } = useTranslation();

  return (
    <div
      className={cn(
        "relative aspect-[303/200] cursor-pointer overflow-hidden rounded-3xl bg-black-1 p-4 outline outline-1 -outline-offset-1 outline-transparent transition-all hover:shadow-subscription-card",
        "max-lg:aspect-[165/150] max-lg:p-[0.625rem]",
        "flex flex-col justify-between",
        className,
      )}
      style={style}
    >
      <div>
        <div className={"flex items-center justify-between"}>
          <p
            className={cn({
              "rounded-full bg-orange-1 px-2 py-1 text-sm font-medium": cashback_percentage,
              "max-lg:px-1 max-lg:py-0.5 max-lg:text-[0.625rem]/3": cashback_percentage,
            })}
          >
            {cashback_percentage ? (
              <>
                {t("Subscription.sale")} {cashback_percentage}%
              </>
            ) : null}
          </p>
          <IconRadio className={"size-5"} color={COLORS["orange-1"]} active={value && value.id === id} />
        </div>
        <div className={"mt-1"}>
          <p className={"text-2xl font-semibold max-lg:text-lg/5"}>
            {t("General.som", { value: (price / 100).thousandSeparator() })}
          </p>
          <p className={"text-grey-1 max-lg:text-xs"}>{t("Subscription.per-days", { value: period, count: period })}</p>
        </div>
      </div>
      <p className={"text-grey-1 max-lg:text-xs"}>
        Оплата каждые <span className={"text-on-primary"}>{period}</span> дней
      </p>
      <span
        className={cn(
          "absolute -bottom-8 right-2 text-[7.5rem]/[8.938rem] text-orange-1 opacity-20",
          "max-lg:-bottom-7 max-lg:-right-3 max-lg:text-[6.125rem]/[7.313rem]",
        )}
      >
        {period}
      </span>
    </div>
  );
};

export default TariffCard;
